import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToHash from "@/components/ScrollToHash";
import SEORouter from "@/components/SEORouter";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import CookieConsent from "@/components/CookieConsent";
import NewsletterModal from "@/components/NewsletterModal";
import { Toaster } from "@/components/ui/sonner";
import { LocaleSync } from "@/i18n/useLocale";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Science from "@/pages/Science";
import Markets from "@/pages/Markets";
import About from "@/pages/About";
import Inquiry from "@/pages/Inquiry";
import DistributorPortal from "@/pages/DistributorPortal";
import Certifications from "@/pages/Certifications";
import Resources from "@/pages/Resources";
import Privacy from "@/pages/Privacy";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminEditor from "@/pages/admin/AdminEditor";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminDistributorApplications from "@/pages/admin/AdminDistributorApplications";
import NotFound from "@/pages/NotFound";
import Preorder from "@/pages/Preorder";
import Brochure from "@/pages/Brochure";

// Localised public-site routes — shared between `/`, `/de/*` and `/ja/*`.
const PublicRoutes = () => (
  <Routes>
    <Route index element={<Home />} />
    <Route path="products" element={<Products />} />
    <Route path="science" element={<Science />} />
    <Route path="markets" element={<Markets />} />
    <Route path="about" element={<About />} />
    <Route path="inquiry" element={<Inquiry />} />
    <Route path="reserve-allocation" element={<Inquiry />} />
    <Route path="preorder" element={<Preorder />} />
    <Route path="pre-order" element={<Preorder />} />
    <Route path="brochure" element={<Brochure />} />
    <Route path="distributor-portal" element={<DistributorPortal />} />
    <Route path="certifications" element={<Certifications />} />
    <Route path="resources" element={<Resources />} />
    <Route path="privacy" element={<Privacy />} />
    <Route path="journal" element={<Blog />} />
    <Route path="journal/:slug" element={<BlogPost />} />
    <Route path="blog" element={<Blog />} />
    <Route path="blog/:slug" element={<BlogPost />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <LocaleSync />
        <ScrollToHash />
        <SEORouter />
        <Navbar />
        <main>
          <Routes>
            {/* Admin — single-language, no locale prefix */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/posts/new" element={<AdminEditor />} />
            <Route path="/admin/posts/edit/:id" element={<AdminEditor />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin/inquiries" element={<AdminInquiries />} />
            <Route path="/admin/distributor-applications" element={<AdminDistributorApplications />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />

            {/* Locale-prefixed public site */}
            <Route path="/de/*" element={<PublicRoutes />} />
            <Route path="/ja/*" element={<PublicRoutes />} />

            {/* Default English public site (no prefix) */}
            <Route path="/*" element={<PublicRoutes />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <CookieConsent />
        <NewsletterModal />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
